import { render } from "./PromotionCardSkeleton.vue?vue&type=template&id=9764c96a"
import script from "./PromotionCardSkeleton.vue?vue&type=script&lang=js"
export * from "./PromotionCardSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__